module.exports = __webpack_public_path__ + "973718ed0bbe730add474b1bfb8f9d57.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_small_x1/public/games/sm_image_1.jpg
// module id = 311
// module chunks = 0